'use client';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const FlightDataContext = createContext(null);

export function FlightDataProvider({ 
  flights, 
  returnFlights = [], 
  responseStructure = "unknown", 
  packageDetails, 
  rawFlights, 
  filterOptions, 
  nextDayCheapText, 
  dontMissCheapText,
  // ✅ YENİ PROP
  availableFilters = null,
  availableSort = null,
  scrollIndex = 1,
  totalScrollIndex = 1,
  // ✅ YENİ: DepartureFlights parent ID bilgileri (one-way için AllocateForm.Id)
  departureFlightsId = null,
  departureFlightsReferenceId = null,
  departureFlightsIsDomestic = null,
  returnFlightsIsDomestic = null,
  // ✅ YENİ: Loading states
  isLoading = false,
  isInitialLoading = false,
  isRefetching = false,
  // ✅ YENİ: Active campaigns
  activeCampaigns = [],
  // ✅ YENİ: Selected campaign ID
  selectedCampaignId: propSelectedCampaignId = null,
  setSelectedCampaignId: propSetSelectedCampaignId,
  // ✅ YENİ: Cheapest bus response
  cheapestBusResponse = null,
  // Reissue akışında gidiş seçiminde paket seçimini es geç (doğrudan selectDepartureFlight)
  skipPackageSelectionForDeparture = false,
  children 
}) {
  // Round-trip için departure flight seçimi state'i
  const [selectedDepartureFlight, setSelectedDepartureFlight] = useState(null);
  const [isShowingReturnFlights, setIsShowingReturnFlights] = useState(false);
  // Campaign ID seçimi state'i - prop varsa onu kullan, yoksa internal state
  const [internalSelectedCampaignId, setInternalSelectedCampaignId] = useState(null);
  const selectedCampaignId = propSelectedCampaignId !== undefined ? propSelectedCampaignId : internalSelectedCampaignId;
  const setSelectedCampaignId = propSetSelectedCampaignId || setInternalSelectedCampaignId;

  // Departure flight seçim fonksiyonu
  const selectDepartureFlight = useCallback((flight) => {
    setSelectedDepartureFlight(flight);
    setIsShowingReturnFlights(true);
  }, []);

  // Return flights'ı gizle ve departure flights'a geri dön
  const resetToDepartureFlights = useCallback(() => {
    setSelectedDepartureFlight(null);
    setIsShowingReturnFlights(false);
  }, []);

  const value = useMemo(() => ({ 
    flights, 
    returnFlights,
    responseStructure,
    packageDetails,
    rawFlights,
    filterOptions,
    nextDayCheapText,
    dontMissCheapText,
    // ✅ YENİ PROP
    availableFilters,
    availableSort,
    scrollIndex,
    totalScrollIndex,
    // ✅ YENİ: DepartureFlights parent ID bilgileri (one-way için AllocateForm.Id)
    departureFlightsId,
    departureFlightsReferenceId,
    departureFlightsIsDomestic,
    returnFlightsIsDomestic,
    // ✅ YENİ: Loading states
    isLoading,
    isInitialLoading,
    isRefetching,
    // ✅ YENİ: Active campaigns
    activeCampaigns,
    // ✅ YENİ: Cheapest bus response
    cheapestBusResponse,
    skipPackageSelectionForDeparture,
    totalCount: flights?.length || 0,
    hasResults: flights?.length > 0,
    // Round-trip departure selection
    selectedDepartureFlight,
    isShowingReturnFlights,
    selectDepartureFlight,
    resetToDepartureFlights,
    // Campaign ID selection
    selectedCampaignId,
    setSelectedCampaignId,
  }), [
    flights, 
    returnFlights, 
    responseStructure, 
    packageDetails, 
    rawFlights, 
    filterOptions, 
    nextDayCheapText, 
    dontMissCheapText,
    // ✅ YENİ DEPENDENCY
    availableFilters,
    availableSort,
    scrollIndex,
    totalScrollIndex,
    departureFlightsId,
    departureFlightsReferenceId,
    departureFlightsIsDomestic,
    returnFlightsIsDomestic,
    // ✅ YENİ DEPENDENCY
    isLoading,
    isInitialLoading,
    isRefetching,
    // ✅ YENİ DEPENDENCY
    activeCampaigns,
    // ✅ YENİ DEPENDENCY
    cheapestBusResponse,
    skipPackageSelectionForDeparture,
    selectedDepartureFlight, 
    isShowingReturnFlights, 
    selectDepartureFlight, 
    resetToDepartureFlights,
    selectedCampaignId,
  ]);
  
  return (
    <FlightDataContext.Provider value={value}>
      {children}
    </FlightDataContext.Provider>
  );
}

export function useFlightDataCtx() {
  const context = useContext(FlightDataContext);
  if (!context) {
    throw new Error('useFlightDataCtx must be used within FlightDataProvider');
  }
  return context;
}